// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__DwMg9","is-private":"style_is-private__Aoz5q"};